import { render, staticRenderFns } from "./AssignClients.vue?vue&type=template&id=f93efa10&"
import script from "./AssignClients.vue?vue&type=script&lang=js&"
export * from "./AssignClients.vue?vue&type=script&lang=js&"
import style0 from "./AssignClients.vue?vue&type=style&index=0&id=f93efa10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports